import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import EfScrollAni from '@/efscrollani';

const PageConPc = dynamic(() => import('@/components/Gitex2023'), {
    ssr: true,
});
const PageConH5 = dynamic(() => import('@/componentsH5/Gitex2023'), {
    ssr: true,
});

export default function Gitex({ SEO }: any) {
    const { isMobile, useLang } = useGlobal();
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const router = useRouter();
    const { locale = 'us' } = router;
    const { t } = useLang('gitex');

    if (typeof window !== 'undefined') {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        return () => {
            setTimeout(() => {
                window.AniContainer?.destroy();
            }, 30);
        };
    }, []);

    return (
        <div className={`${styles.Gitex} gitex`}>
            <PageLayout theme="black">
                <SEO title={t('seo_title') || 'gitex'} description={t('seo_desc') || 'gitex'} />
                <SEOlinksA list={['sa']} locale={locale} pathname={router.asPath.substr(1)} />
                <PageCon />
            </PageLayout>
        </div>
    );
}

export async function getServerSideProps({ locale }: { locale: string }) {
    const whiteLocaleList = ['sa'];
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
